import { YStack, XStack, View } from "tamagui";
import { v2 } from "@screen/Home/pages/GasShop/skin";

/**
 * 帳戶詳情頁的區塊骨架。
 *
 * 配色、shimmer 與 prefers-reduced-motion 的處理都沿用首頁骨架（homeSkeleton.ui），
 * 維持同一套語彙；刻意不畫任何文字或數字——先給一個馬上會被推翻的值，比留白更擾人。
 *
 * 尺寸都對齊各自的真實列，資料回來時不跳版。
 */

const BASE = "#e3e8ef";
const HIGHLIGHT = "#eef2f7";

const shimmer = `
@keyframes accountSkeletonShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
@media (prefers-reduced-motion: reduce) {
  .account-sk { animation: none; }
}
`;

const Bar = ({ height, width, radius = 6 }: { height: number; width: number | string; radius?: number }) => (
  <div
    className="account-sk"
    style={{
      height,
      width,
      borderRadius: radius,
      background: `linear-gradient(90deg, ${BASE} 25%, ${HIGHLIGHT} 37%, ${BASE} 63%)`,
      backgroundSize: "200% 100%",
      animation: "accountSkeletonShimmer 1.4s ease-in-out infinite",
    }}
  />
);

/**
 * 送貨地址列骨架。
 * rows 預設 2——夠暗示「可能不只一筆」，又不會撐出一張過長的空卡。
 */
export const AddressRowsSkeleton = ({ rows = 2 }: { rows?: number }) => (
  <YStack>
    <style>{shimmer}</style>
    {Array.from({ length: rows }).map((_, i) => (
      <XStack key={i} ai="center" gap="$2" px="$3.5" py="$3" bbw={1} bbc={v2.divider}>
        <View w={18} ai="center" jc="center" flexShrink={0}>
          <Bar height={17} width={17} radius={5} />
        </View>
        {/* 兩列寬度不同：等寬的灰條看起來像表格，不像還沒載入的地址 */}
        <Bar height={13.5} width={i === 0 ? "72%" : "54%"} />
      </XStack>
    ))}
  </YStack>
);

/** 成員 chips 骨架：對齊真實 chip 的膠囊外型與行高（26px 頭像 + py $1.5）。 */
export const MemberChipsSkeleton = ({ chips = 2 }: { chips?: number }) => (
  <XStack fw="wrap" gap="$2" px="$3.5" pt="$3.5" pb="$3">
    <style>{shimmer}</style>
    {Array.from({ length: chips }).map((_, i) => (
      <Bar key={i} height={38} width={i === 0 ? 104 : 88} radius={999} />
    ))}
  </XStack>
);
